import styled from 'styled-components';
import { colors, media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import Link from '@bitcoin-portal/bitcoincom-pkg-components/dist/Link';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const Label = styled.div`
  color: ${colors.solid.textOne};
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin-right: 16px;
  display: flex;
  flex-flow: row wrap;
  max-width: 100px;

  ${media.md`
    font-size: 16px;
    line-height: 28px;
  `}

  ${media.xl`
    min-width: fit-content;
    max-width: unset;
    font-size: 20px;
    line-height: 40px;
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  box-sizing: border-box;
  margin-top: 0;
`;

export const Content = styled.div`
  padding: 0 16px;
  ${media.md`
    padding: 0;
  `}
`;
export const CustomContentBlock = styled(ContentBlock)`
  padding-top: 0;
  margin-top: 0;
  & > div > div {
    padding-top: 0;
    margin-top: 0;
  }
`;
export const CustomImg = styled(LazyLoadImage)`
  margin-top: 64px;
`;
export const CustomTitle = styled(Paragraph)`
  color: #00c48b;
  font-size: 24px;
  margin-top: 64px;
  font-weight: bold;
`;
export const FailedTitle = styled(Paragraph)`
  color: #6b717e;
  font-size: 24px;
  margin-top: 32px;
  font-weight: bold;
`;

export const PendingTitle = styled(Paragraph)`
  color: #f09e0e;
  font-size: 24px;
  margin-top: 32px;
  font-weight: bold;
`;

export const AnimationWrapper = styled.div`
  max-width: 200px;
  margin: auto;
`;

export const CustomLink = styled(Link)`
  color: #00c48b;
`;

export const CustomLabel = styled(Label)`
  color: #6b717e;
  font-size: 14px;
  text-align: left;
`;
export const CustomField = styled(Paragraph)`
  color: #131720;
  font-size: 16px;
  text-align: left;
`;
